(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shopifyexplorer-top-bar"]) return;
  try {
    
function Shopifyexplorer_setCookie (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function Shopifyexplorer_getCookie (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

var cookiesName = 'Shopifyexplorer_topBar';

if (!Shopifyexplorer_getCookie(cookiesName)) {
  var topBarEl = document.querySelector('.shopifyexplorer-top-bar');
  if (topBarEl) {
    topBarEl.classList.add('active');
  }
}

var closeEl = document.querySelector('.shopifyexplorer-top-bar__close');
if (closeEl) {
  closeEl.addEventListener('click', function (e) {
    e.preventDefault();
    Shopifyexplorer_setCookie(cookiesName, true, 365);
    topBarEl.classList.remove('active');
  });
}

  } catch(e) { console.error(e); }
})();
})();
